import React from 'react';
import { ButtonLink } from '../components/ui/ButtonLink';
import { DiagonalAccent } from '../components/ui/DiagonalAccent';
import { useSeo } from '../hooks/useSeo';
import { pageMeta } from '../data/seo';
export function NotFound() {
  useSeo(pageMeta.notFound);
  return <section className="bg-charcoal py-28 md:py-36" data-id="element-787" data-mp="154xwa1y5xxeh">
      <div className="mx-auto max-w-site px-5 md:px-8" data-id="element-788" data-mp="156iuq2nlm0hm">
        <DiagonalAccent className="h-10 w-32" data-id="element-789" data-mp="1a4kd0ld79vs1" />
        <h1 className="mt-8 font-display text-[64px] font-extrabold uppercase leading-[0.9] text-white md:text-[96px]" data-id="element-790" data-mp="1a3sfv63yfpzn">
          Page not found
        </h1>
        <p className="mt-6 max-w-xl text-lg text-steel-300" data-id="element-791" data-mp="1jtc30nypa60b">That page has moved or no longer exists.</p>
        <div className="mt-10 flex flex-col gap-3 sm:flex-row" data-id="element-792" data-mp="1nvp614m2bpte">
          <ButtonLink to="/" showArrow data-id="element-793" data-mp="1sujxeuy3imp4">
            Back to Home
          </ButtonLink>
          <ButtonLink to="/projects" variant="outline" data-id="element-794" data-mp="1ssfmvu5oypfv">
            View Projects
          </ButtonLink>
        </div>
      </div>
    </section>;
}